import React, { memo, useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from "highcharts/highcharts-more";
// import solidGauge from "highcharts/modules/solid-gauge";
import { useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { riskProfileMasterData } from '../../../redux-store/actions';
import { profileType, RiskProfileMaster } from '../../../redux-store/types/api-types';

highchartsMore(Highcharts);
interface CustomGaugeChartProps {
    data: number
    riskProfileGroup?: string | null
    company?: string | null
}
const CustomGaugeChart = memo(function CustomGaugeChart(props: CustomGaugeChartProps): JSX.Element {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [profileBands, setProfileBands] = useState<profileType[]>([]);

    useEffect(() => {
        (async function () {
            try {
                const response = (await dispatch(riskProfileMasterData({
                    riskProfileGroup: props?.riskProfileGroup ?? null,
                    company: props?.company ?? null,
                }))) as unknown as RiskProfileMaster;
                setProfileBands(response?.profile ?? []);
            } catch (e) {
                console.error((e as Error).message);
            }
        })();
    }, [props?.riskProfileGroup, props?.company]);

    
    const overallMinScore = profileBands.length
        ? Math.min(...profileBands.map(p => p.minScore))
        : 0;

    const overallMaxScore = profileBands.length
        ? Math.max(...profileBands.map(p => p.maxScore))
        : 240;

    const segmentSize = (overallMinScore + overallMaxScore) / 5;

    const gaugeBandColors = ['#00E676', '#FFF176', '#FDD835', '#FF6E40', '#DD2C00'];

    const dynamicPlotBands = Array.from({ length: 5 }, (_, index) => ({
        from: overallMinScore + index * segmentSize + (index === 0 ? 0 : 1),
        to: overallMinScore + (index + 1) * segmentSize,
        color: gaugeBandColors[index],
        thickness: 12,
    }));

    const options = {
        tooltip: {
            enabled: false
        },
        chart: {
            animation: true,
            // height: 300,
            style: {
                fontFamily: `${theme.typography.fontFamily}`,
                borderWidth: 0
            },
            backgroundColor: `${theme.palette.common.white}`,
            spacingBottom: 0
        },
        title: {
            text: ''
        },
        pane: {
            center: ['50%', '50%'],
            size: '100%',
            startAngle: -150,
            endAngle: 150,
            background: [{
                borderWidth: 0,
                backgroundColor: theme.palette.common.white,
            }]
        },
        yAxis: {
            min: overallMinScore,
            max: overallMaxScore,
            lineWidth: 0,
            minorTickInterval: 'undefined',
            minorTickLength: 0,
            minorTickPosition: 'undefined',
            tickPixelInterval: 50,
            tickWidth: 3,
            tickPosition: 'undefined',
            tickLength: 0,
            labels: {
                step: 2,
                rotation: 'auto'
            },
            title: {
                text: ''
            },
            plotBands:  dynamicPlotBands
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            series: {
                center: ['50%', '115%']
            }
        },
        series: [{
            type: 'gauge',
            data: [Math.min(overallMaxScore, props?.data)],
            dataLabels: {
                useHTML: true,
                align: 'center',
                formatter: function (this: any) {
                    return '<span style="color:grey;">' + 'Score' + '</span><br/>' +
                        '<span style="color:black;font-weight:bold;font-size: 24px;">' + props?.data + '</span>'
                },
                borderWidth: 0
            },
            dial: {
                radius: '90%',
                backgroundColor: 'gray',
                baseWidth: 12,
                baseLength: '0%',
                rearLength: '0%',
                // Change the needle type to arrow
                arrowLength: 10,
                arrowWidth: 6,
                shape: 'arc'
                // Arrow color
            }
        },
        ]
    };
    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            // containerProps={{ style: { height: '50%' } }}
            containerProps={{ style: { height: '100%', width: "100%" } }}
        />
    )
})
export default CustomGaugeChart
